var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 7,
    viewBox: "0 0 24 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_326_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3.24167H21.5938",
    stroke: "white",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0834 0.825012L22.5001 3.24168L20.0834 5.65834",
    stroke: "white",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_326_526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 6,
    fill: "white",
    transform: "translate(0.75 0.0750122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0cf09d6c39d989f556e77ef6b4356319.svg";
export { ForwardRef as ReactComponent };